var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrapes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 28,
    viewBox: "0 0 23 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4A7054",
    d: "M15.196 1.752c-.121-.371-.513-.573-.878-.45L11.5 2.25V.71c0-.392-.31-.709-.695-.709-.383 0-.694.317-.694.708v2.01l-3.13 1.051c-.363.123-.561.523-.442.895.121.37.513.572.878.45l2.694-.907v4.375c0 .391.311.709.694.709.385 0 .695-.318.695-.709V3.74l3.254-1.094c.364-.122.562-.522.442-.894",
    transform: "translate(.356 .945)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1E040",
    d: "M16.116 9.461c0 1.512-1.202 2.738-2.686 2.738s-2.686-1.226-2.686-2.738 1.202-2.737 2.686-2.737 2.686 1.225 2.686 2.737M10.744 9.461c0 1.512-1.202 2.738-2.686 2.738s-2.686-1.226-2.686-2.738 1.202-2.737 2.686-2.737 2.686 1.225 2.686 2.737M5.372 9.461c0 1.512-1.202 2.738-2.686 2.738S0 10.973 0 9.461s1.202-2.737 2.686-2.737S5.372 7.949 5.372 9.46M21.488 9.461c0 1.512-1.202 2.738-2.686 2.738s-2.686-1.226-2.686-2.738 1.202-2.737 2.686-2.737 2.686 1.225 2.686 2.737M16.116 18.937c0 1.512-1.202 2.738-2.686 2.738s-2.686-1.226-2.686-2.738S11.946 16.2 13.43 16.2s2.686 1.226 2.686 2.738M10.744 18.937c0 1.512-1.202 2.738-2.686 2.738s-2.686-1.226-2.686-2.738S6.574 16.2 8.058 16.2s2.686 1.226 2.686 2.738",
    transform: "translate(.356 .945)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1E040",
    d: "M18.802 14.228c0 1.512-1.202 2.738-2.686 2.738s-2.686-1.226-2.686-2.738 1.202-2.738 2.686-2.738 2.686 1.226 2.686 2.738M13.43 14.228c0 1.512-1.202 2.738-2.686 2.738s-2.686-1.226-2.686-2.738 1.202-2.738 2.686-2.738 2.686 1.226 2.686 2.738M8.058 14.228c0 1.512-1.202 2.738-2.686 2.738s-2.686-1.226-2.686-2.738 1.202-2.738 2.686-2.738 2.686 1.226 2.686 2.738M13.43 23.728c0 1.512-1.202 2.738-2.686 2.738s-2.686-1.226-2.686-2.738 1.202-2.737 2.686-2.737 2.686 1.225 2.686 2.737",
    transform: "translate(.356 .945)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrapes);
export default __webpack_public_path__ + "static/media/grapes.d4b182a10c4f8ce4bef48a6685c73566.svg";
export { ForwardRef as ReactComponent };